<div class="voting-results-root card-block">
  <div class="voting-results-header mb-3">
    <h5 class="mb-1">Voting results</h5>
    <p class="text-muted small mb-0">
      Approve and reject counts per agenda item and per uploaded meeting minutes. Open <strong>View details</strong> to see who voted and any comments on reject.
    </p>
  </div>

  <div *ngIf="loading" class="text-center py-5 text-muted">
    <i class="fa fa-spinner fa-spin fa-2x" aria-hidden="true"></i>
    <div class="mt-2">Loading vote data…</div>
  </div>

  <div *ngIf="!loading && loadError" class="alert alert-danger">{{ loadError }}</div>

  <div *ngIf="!loading && !loadError && !rows?.length && !minuteRows?.length" class="alert alert-info">
    <ng-container *ngIf="!agendas?.length && !hasMinutesDocuments()">
      No agendas and no draft or final minutes file for this meeting yet. Voting appears once agendas exist or minutes are uploaded.
    </ng-container>
    <ng-container *ngIf="agendas?.length && !hasMinutesDocuments()">
      No vote data loaded. Open this tab again after attendees have voted on agendas.
    </ng-container>
    <ng-container *ngIf="!agendas?.length && hasMinutesDocuments()">
      No agendas for this meeting; minute voting summary appears below when draft or final minutes are uploaded.
    </ng-container>
  </div>

  <div *ngIf="!loading && !loadError && agendas?.length" class="table-responsive voting-results-table-wrap mb-4">
    <table class="table table-hover voting-results-table">
      <thead>
        <tr>
          <th style="width: 8%">#</th>
          <th style="width: 42%">Agenda</th>
          <th class="text-center" style="width: 12%">Approve</th>
          <th class="text-center" style="width: 12%">Reject</th>
          <th class="text-center" style="width: 12%">Total</th>
          <th style="width: 14%"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <td class="align-middle">{{ row.agenda?.AgendaNumber }}</td>
          <td class="align-middle">
            <div class="font-weight-bold">{{ row.agenda?.AgendaTitle }}</div>
            <div *ngIf="row.errorMessage" class="small text-danger mt-1">{{ row.errorMessage }}</div>
          </td>
          <td class="text-center align-middle">
            <span class="badge badge-vote badge-approve">{{ row.summary?.approveCount ?? 0 }}</span>
          </td>
          <td class="text-center align-middle">
            <span class="badge badge-vote badge-reject">{{ row.summary?.rejectCount ?? 0 }}</span>
          </td>
          <td class="text-center align-middle">{{ row.summary?.totalVotes ?? 0 }}</td>
          <td class="align-middle text-end">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              [disabled]="!row.summary"
              (click)="openDetail(voteDetailModal, row)"
            >
              View details
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!loading && !loadError && minuteRows?.length" class="mt-2">
    <h6 class="mb-2">Meeting minutes</h6>
    <div class="table-responsive voting-results-table-wrap">
      <table class="table table-hover voting-results-table">
        <thead>
          <tr>
            <th style="width: 50%">Minutes</th>
            <th class="text-center" style="width: 12%">Approve</th>
            <th class="text-center" style="width: 12%">Reject</th>
            <th class="text-center" style="width: 12%">Total</th>
            <th style="width: 14%"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of minuteRows">
            <td class="align-middle">
              <div class="font-weight-bold">{{ row.label }}</div>
              <div *ngIf="row.errorMessage" class="small text-danger mt-1">{{ row.errorMessage }}</div>
            </td>
            <td class="text-center align-middle">
              <span class="badge badge-vote badge-approve">{{ row.summary?.approveCount ?? 0 }}</span>
            </td>
            <td class="text-center align-middle">
              <span class="badge badge-vote badge-reject">{{ row.summary?.rejectCount ?? 0 }}</span>
            </td>
            <td class="text-center align-middle">{{ row.summary?.totalVotes ?? 0 }}</td>
            <td class="align-middle text-end">
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                [disabled]="!row.summary"
                (click)="openMinuteDetail(voteDetailModal, row)"
              >
                View details
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #voteDetailModal let-modal>
  <div class="modal-header vote-detail-modal-header">
    <div *ngIf="detailAgenda">
      <div class="text-uppercase text-muted small mb-1">Agenda item {{ detailAgenda?.AgendaNumber }}</div>
      <h4 class="modal-title mb-0">{{ detailAgenda?.AgendaTitle }}</h4>
      <div class="small text-muted mt-2" *ngIf="detailSummary">
        <span class="badge badge-pill badge-light border">{{ detailSummary.totalVotes }} total vote(s)</span>
      </div>
    </div>
    <div *ngIf="!detailAgenda && detailMinuteLabel">
      <div class="text-uppercase text-muted small mb-1">Meeting minutes</div>
      <h4 class="modal-title mb-0">{{ detailMinuteLabel }}</h4>
      <div class="small text-muted mt-2" *ngIf="detailSummary">
        <span class="badge badge-pill badge-light border">{{ detailSummary.totalVotes }} total vote(s)</span>
      </div>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body vote-detail-modal-body">
    <div class="row vote-summary-cards mb-4" *ngIf="detailSummary">
      <div class="col-md-4 mb-2 mb-md-0">
        <div class="vote-card vote-card-approve">
          <div class="vote-card-count">{{ detailSummary.approveCount }}</div>
          <div class="vote-card-label">Approve</div>
        </div>
      </div>
      <div class="col-md-4 mb-2 mb-md-0">
        <div class="vote-card vote-card-reject">
          <div class="vote-card-count">{{ detailSummary.rejectCount }}</div>
          <div class="vote-card-label">Reject</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="vote-card vote-card-total">
          <div class="vote-card-count">{{ detailSummary.totalVotes }}</div>
          <div class="vote-card-label">Total</div>
        </div>
      </div>
    </div>

    <h6 class="text-uppercase text-muted small mb-3">Vote breakdown</h6>
    <ul class="list-unstyled vote-breakdown-list mb-0">
      <li *ngFor="let v of detailVoters" class="vote-breakdown-item">
        <div class="d-flex align-items-start">
          <div class="vote-avatar">{{ initials(v.userName) }}</div>
          <div class="flex-grow-1" style="min-width: 0">
            <div class="d-flex flex-wrap justify-content-between align-items-start gap-2">
              <div>
                <div class="font-weight-bold">{{ v.userName }}</div>
                <div class="small text-muted" *ngIf="v.userEmail">{{ v.userEmail }}</div>
                <div class="small text-muted" *ngIf="v.votedAt">
                  {{ v.votedAt | date : 'medium' }}
                </div>
              </div>
              <div>
                <span class="badge badge-pill" [ngClass]="v.voteType === 'APPROVE' ? 'badge-success' : 'badge-danger'">
                  {{ v.voteType === 'APPROVE' ? 'Approve' : 'Reject' }}
                </span>
              </div>
            </div>
            <div
              *ngIf="v.voteType === 'REJECT' && v.comments"
              class="vote-reject-comment mt-2"
            >
              <strong>Comment</strong>
              <div>{{ v.comments }}</div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <p *ngIf="detailVoters.length === 0" class="text-muted mb-0">No votes recorded for this item yet.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
  </div>
</ng-template>
